/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
import { ILogger } from './Context';

export class ConsoleLogger implements ILogger {
  logVerbose(message: string): void {
    console.debug(message);
  }

  logInfo(message: string): void {
    console.info(message);
  }

  logWarning(message: string): void {
    console.warn(message);
  }

  logError(message: string): void {
    console.error(message);
  }

  clone(): ILogger {
    return this;
  }

  setAppendedData(key: string, value: string): void {
    // Do nothing
  }
}
